import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { BudgetDeleteResult } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';
import { BUDGETS } from './budgets.query';

const useDeleteBudgetFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (budgetId: string): Promise<BudgetDeleteResult> => {
    const raw = await request<any>(`${BUDGETS}/${encodeURIComponent(budgetId)}`, 'DELETE');
    return unwrapEnvelope<BudgetDeleteResult>(raw);
  }, 'Failed to delete budget');
};

export const useDeleteBudgetMutation = () => {
  const queryClient = useQueryClient();
  const deleteFn = useDeleteBudgetFn();
  return useMutation({
    mutationFn: (budgetId: string) => deleteFn(budgetId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiKeys.budgets() });
    },
  });
};
